import { create } from 'zustand'
import { api } from '../api/client'
import type { User } from '../types'

interface AuthUser extends User {
  is_admin?: boolean
}

interface AuthState {
  user: AuthUser | null
  token: string | null
  initialized: boolean
  login: (token: string, user: AuthUser) => void
  logout: () => void
  setUser: (user: AuthUser) => void
  checkAuth: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  token: localStorage.getItem('authToken'),
  initialized: false,

  login: (token, user) => {
    localStorage.setItem('authToken', token)
    set({ token, user, initialized: true })
  },

  logout: () => {
    localStorage.removeItem('authToken')
    set({ token: null, user: null, initialized: true })
  },

  setUser: (user) => set({ user }),

  checkAuth: async () => {
    const token = get().token
    if (!token) {
      set({ initialized: true })
      return
    }
    try {
      const user = await api.get<AuthUser>('/api/auth/me')
      set({ user, initialized: true })
    } catch {
      localStorage.removeItem('authToken')
      set({ token: null, user: null, initialized: true })
    }
  },
}))
